import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import LetShiftTable from "./late-shift-table";
import Paginat from "@/components/lib/paginat";
import { useSearch } from "@/hooks/useSearch";
import { usePagination } from "@/hooks/usePagination";
import { TabsContent } from "@/components/ui/tabs";
import { Search } from "lucide-react";
import OnlyTableSekeleton from "@/components/skeleton/only-table-skeleton";
import { getAllStaffSchedules } from "@/api/new-api/staff-management/staff/staff";
import useAuth from "@/hooks/useAuth";

function OurLetShiftTabs() {
  const { user } = useAuth();
  const [searchText, setSearchText] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [allStaffSchedules, setAllStaffSchedules] = useState([]);
  const [activeShiftType, setActiveShiftType] = useState("weekly");
  const [loading, setLoading] = useState(false);

  const fetchAllStaffSchedules = async () => {
    setLoading(true);
    try {
      const response = await getAllStaffSchedules(user?.restaurant_id, perPage);
      if (response.status === "success") {
        setAllStaffSchedules(response?.data.staff_schedules);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllStaffSchedules();
  }, [perPage]);

  const filteredShifts = allStaffSchedules?.filter((item) =>
    item?.shift_schedule?.some(
      (schedule) =>
        schedule?.shift_type?.toLowerCase() === activeShiftType.toLowerCase()
    )
  );

  const searchData = useSearch(filteredShifts, searchText, ["id", "name"], 300);

  const { paginatedData, paginationInfo, onPageChange } = usePagination(
    searchData,
    perPage
  );

  if (loading) return <OnlyTableSekeleton header={false} />;
  return (
    <TabsContent className="" value={"ourletshift"}>
      <Card className="bg-transparent border-0">
        <CardContent className="flex justify-between flex-col gap-5 items-center mt-4">
          <div className="w-full flex justify-between lg:flex-row flex-col gap-5 items-start lg:items-center">
            <div>
              <div className="h-10 px-0.5 bg-cblack3 border border-gray-600 flex rounded justify-center items-center">
                <div
                  onClick={() => setActiveShiftType("weekly")}
                  className={`${activeShiftType === "weekly" ? "bg-cyellow" : "text-white"
                    } px-3 py-1 rounded cursor-pointer text-black`}
                >
                  Weekly
                </div>
                <div
                  onClick={() => setActiveShiftType("daily")}
                  className={`${activeShiftType === "daily" ? "bg-cyellow" : "text-white"
                    } px-3 py-1 rounded cursor-pointer text-black`}
                >
                  Daily
                </div>
              </div>
            </div>
            <div className="flex flex-col  gap-1.5 justify-end items-end">
              <div className="flex gap-3 justify-center items-center">
                <div className="relative">
                  <Search
                    size={18}
                    className="text-cwhite3 absolute top-2 left-2"
                  />
                  <Input
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder="Search by Name or ID"
                    className="bg-cblack3 pl-8"
                  />
                </div>
                <div className="flex gap-1 justify-center items-center">
                  <h3 className="text-white">Show</h3>
                  <Select
                    onValueChange={(value) => setPerPage(Number(value))}
                    value={perPage.toString()}
                  >
                    <SelectTrigger className="w-[60px]">
                      <SelectValue placeholder="10" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectGroup>
                        <SelectItem value="10">10</SelectItem>
                        <SelectItem value="20">20</SelectItem>
                        <SelectItem value="40">40</SelectItem>
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full">
            <LetShiftTable
              activeShiftType={activeShiftType}
              allStaffSchedules={paginatedData}
            />
          </div>
        </CardContent>
      </Card>
      <Paginat
        pagination={paginationInfo}
        onPageChange={onPageChange}
        className="mt-4"
      />
    </TabsContent>
  );
}

export default OurLetShiftTabs;
